import React, { useState, useEffect } from 'react';
// api client
import apiClient from './app/apiClient.js'
import { getBrandAlt, getLoginLogoSrc } from './app/branding.js'
import { usersApi } from './app/users.js'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'


import { createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#7487a6"
    }
  }
});

function LoginForm(props){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return  <ThemeProvider theme={theme}>
    <Container component="main" maxWidth="xs">
      <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              height: 100,
              maxWidth: '100%',
            }}
            component="img"
            alt={getBrandAlt()}
            src={getLoginLogoSrc()}
            className="brand-logo-login"
          />
          <Box component="form" onSubmit={(event) => {
            props.login({email: email, password: password})
            event.preventDefault();
          }} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={event => setEmail(event.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={event => setPassword(event.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
          </Box>
        </Box>
    </Container>
  </ThemeProvider>

}

export default LoginForm;